//I have to put the REFERENCE below, otherwise angular will give me some errors. Don't delete it, its not really a comment.
/// <reference types="@types/googlemaps" />

import { Component, OnInit, NgZone, AfterViewInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import Swal from 'sweetalert2';
import { AvantoAlert } from 'src/app/util/Alerts';

@Component({
  selector: 'app-geolocation',
  templateUrl: './geolocation.component.html',
  styleUrls: ['./geolocation.component.scss']
})
export class GeolocationComponent implements OnInit, AfterViewInit {

  @ViewChild("autocompleteAddress") addressAutoComplete:ElementRef;
  @Output() locationWasChosen:EventEmitter<any> = new EventEmitter();
  @Input() useLgFont:boolean;
  @Input() clearFieldAfterSelection:boolean;

  
  //Makes reference to the text inside of the field you type your address in
  addressField:string;
  //Used to block user input while the address is being processed
  isProcessingAddress:boolean;
  //Reference to the address and coordinates received from google
  selectedAddress:string;

  private Toast = Swal.mixin({ toast: true, position: 'bottom-end', showConfirmButton: false, timer: 10000 })

  constructor(private mapsAPILoader: MapsAPILoader, private ngZone:NgZone, private avantoSession:AvantoSessionService) { }

  ngOnInit() {
    this.isProcessingAddress = false;
  }

  ngAfterViewInit(){
    /** Sets up the auto complete functionality for the address field */
    this.mapsAPILoader.load().then(()=>{
      //You will need @types/googlemaps for this to work. Download it from NPM!
      let autocomplete = new google.maps.places.Autocomplete(
        this.addressAutoComplete.nativeElement, 
        {componentRestrictions:{country:'CA'}}
        );
        autocomplete.addListener("place_changed",()=>{
        this.isProcessingAddress = true;
        this.ngZone.run(()=>{
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if(place.geometry == null){
            this.couldNotGeValidLocation();
            return;
          }else{
            this.saveMyLocation(place);
          }
        });
      })
    })
  }

  /** This is the method called when the "FIND MY LOCATION" button is clicked */
  findMyAddress(){
    this.isProcessingAddress = true;

    const nav:any = navigator;
    nav.permissions.query({ name: 'geolocation' }).then((response)=>{

      if(response.state == "denied"){
        AvantoAlert.toast("error", "Could not get permissions to fetch your location automatically. Try typing your address.")
        this.isProcessingAddress = false;
      }else{
        nav.geolocation.getCurrentPosition( pos => {
          const latlng = {lat: pos.coords.latitude, lng: pos.coords.longitude};
          const geocoder = new google.maps.Geocoder();
          geocoder.geocode({'location': latlng}, (results, status) => {
            this.ngZone.run(()=>{//Code is run inside of ngZone (angular zone), so when it is done, angular will update the fields automatically
              if (status === google.maps.GeocoderStatus.OK) {
                if (results[1]) {
                  this.saveMyLocation(results[1])
                  return;
                } else {
                  console.error('Geocoder failed: No results found');
                  this.couldNotGeValidLocation();
                  return;
                }
              } else {
                console.error('Geocoder failed due to: ' + status);
                this.couldNotGeValidLocation();
                return;
              }
            });
          });
        });
      }
    })
  }

  /** Checks if the selected google location is valid and saves it on the session */
  // validateLocationAndSave(place){
  //   let streetNumber = "";
  //   let street = "";
  //   let city = "";
  //   let postalCode = "";

  //   console.log(place)
    
  //   place.address_components.forEach((addressComponent)=>{
  //     if(addressComponent.types.includes("street_number")){
  //       streetNumber = addressComponent.short_name;
  //     }else if(addressComponent.types.includes("route")){
  //       street = addressComponent.short_name;
  //     }else if(addressComponent.types.includes("sublocality_level_1")){
  //       city = addressComponent.short_name;
  //     }else if(addressComponent.types.includes("postal_code") && !addressComponent.types.includes("postal_code_prefix")){
  //       postalCode = addressComponent.short_name;
  //     }
  //   })

  //   this.saveMyLocation()
  // }

  /** Saves the selected location in the session */
  saveMyLocation(place){
    this.selectedAddress = place.formatted_address;
    const lat =  place.geometry.location.lat();
    const lng = place.geometry.location.lng()

      this.avantoSession.setCustomerAddress(this.selectedAddress, lat, lng, null).then(()=>{
        //Updates the field with the full addrress
        if(this.clearFieldAfterSelection){
          this.clearAddressField();
        }else{
          this.addressField = this.selectedAddress;
        }
        this.isProcessingAddress = false;
        this.locationWasChosen.emit();
      }, (error)=>{
        this.isProcessingAddress = false;
        this.couldNotGeValidLocation();
      });
  }

  /** Called whenever you unfocus the address field.
   * This method will write the currently selected address on it.
   * This is important in case the user types some weird stuff on the field and then click somewhere else...
   * This will make sure the field will always have the selected address (retreived from google) or blank (if no address selected)
   */
  addressFieldBlurred(){
    this.addressField = this.selectedAddress;
  }

  clearAddressField(){
    this.isProcessingAddress = false;
    this.addressField = "";
  }

  couldNotGeValidLocation(){
    this.clearAddressField();
    Swal.fire(
      'Could not save your address.',
      'Please try again',
      'warning'
    );
  }
}
